import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import BernoulliHome from './BernoulliHome/BernoulliHome';
import AutodeskAssistant from './AutodeskAssistant/AutodeskAssistant';
import BernoulliIcon from '@/components/icons/BernoulliIcon';
import AssistantIcon from '@/components/icons/AssistantIcon';

const bernoulliRoute = {
  title: 'Bernoulli',
  to: '/bernoulli',
  icon: <BernoulliIcon />,
  render: <BernoulliHome />,
};

const autodeskAssistantRoute = {
  title: 'Autodesk Assistant',
  to: '/autodesk-assistant',
  icon: <AssistantIcon />,
  render: <AutodeskAssistant />,
};

export function usePageRoutes() {
  const isAutodeskAssistantEnabled = useIsFeatureEnabled(
    'info360-embed-autodesk-assistant',
  );

  return useMemo(() => {
    const routes = [bernoulliRoute];
    if (isAutodeskAssistantEnabled) {
      console.log('[Bernoulli] Autodesk Assistant is enabled');
      routes.push(autodeskAssistantRoute);
    }
    return routes;
  }, [isAutodeskAssistantEnabled]);
}

const pageRoutes = [bernoulliRoute];

// Legacy export for backward compatibility
export const miniPageRoutes = pageRoutes;
export default pageRoutes;
